import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import Button from 'reactstrap/lib/Button';
import Label from 'reactstrap/lib/Label';
import Input from 'reactstrap/lib/Input';
import { noop } from 'lodash-es';

import './buttons-radio-input.scss';

export class ButtonsRadioInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.defaultValue,
    };
  }

  setValue = event => {
    const { onChange } = this.props;
    const {
      target: { value },
    } = event;

    this.setState({ value }, () => {
      onChange(event);
    });
  };

  // Used for validation
  // eslint-disable-next-line no-restricted-syntax
  get value() {
    return this.state.value;
  }

  render() {
    const { name, defaultValue, options, onBlur } = this.props;

    return (
      <Row className="buttons-radio-list d-flex">
        {options.map(({ label, value }) => {
          const inputId = `button-radio-${name}-${value}`;
          return (
            <Col xs={6} md={3} className="mb-1" key={inputId}>
              <Input
                className="radio-input m-0"
                type="radio"
                value={value}
                name={name}
                id={inputId}
                aria-label={label}
                onChange={this.setValue}
                onBlur={onBlur}
                defaultChecked={value === defaultValue}
              />
              <Button
                tag={Label}
                for={inputId}
                color="secondary"
                size="lg"
                className="btn-label w-100 py-1 px-0_5 mb-0 fw-normal"
              >
                {label}
              </Button>
            </Col>
          );
        })}
      </Row>
    );
  }
}

ButtonsRadioInput.propTypes = {
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  defaultValue: PropTypes.string,
};

ButtonsRadioInput.defaultProps = {
  onBlur: null,
  onChange: noop,
  options: [],
  defaultValue: undefined,
};
